import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.login-saml-client-sso', {
        url: '/loginSaml/client/sso/:tracker',
        component: 'loginSamlClientSso',
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/public/client-saml-login/client-saml-login.state.js